import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type I07SparkleAppointmentConfirmationProps = RenderingProps<
  DynamicPlaceholderParams & TranslationOptionsParams & AnchorTargetParams
>;
